import React, { useState } from "react";
import { Tab, Nav, Form, InputGroup, Button, Card, Modal } from "react-bootstrap";
import { BsSearch, BsStarFill, BsStarHalf, BsStar } from "react-icons/bs";
import { NavLink } from "react-router-dom";
import PrimarySidebar from "../PrimarySidebar/PrimarySidebar";

const companies = [
  { id: 1, logo: "https://logo.clearbit.com/apple.com", name: "Apple Inc.", rating: 4.8 },
  { id: 2, logo: "https://logo.clearbit.com/microsoft.com", name: "Microsoft Corporation", rating: 4.7 },
  { id: 3, logo: "https://logo.clearbit.com/amazon.com", name: "Amazon.com, Inc.", rating: 4.6 },
  { id: 4, logo: "https://logo.clearbit.com/google.com", name: "Google LLC", rating: 4.7 },
  { id: 5, logo: "https://logo.clearbit.com/meta.com", name: "Meta (Facebook)", rating: 4.5 },
  { id: 6, logo: "https://logo.clearbit.com/tesla.com", name: "Tesla Inc.", rating: 4.6 },
  { id: 7, logo: "https://logo.clearbit.com/netflix.com", name: "Netflix, Inc.", rating: 4.3 },
  { id: 8, logo: "https://logo.clearbit.com/samsung.com", name: "Samsung Electronics", rating: 4.4 },
  { id: 9, logo: "https://logo.clearbit.com/adobe.com", name: "Adobe Systems", rating: 4.5 },
  { id: 10, logo: "https://logo.clearbit.com/intel.com", name: "Intel Corporation", rating: 4.4 },
  { id: 11, logo: "https://logo.clearbit.com/nvidia.com", name: "NVIDIA Corporation", rating: 4.7 },
  { id: 12, logo: "https://logo.clearbit.com/ibm.com", name: "IBM Corporation", rating: 4.2 },
  { id: 13, logo: "https://logo.clearbit.com/oracle.com", name: "Oracle Corporation", rating: 4.1 },
  { id: 14, logo: "https://logo.clearbit.com/airbnb.com", name: "Airbnb, Inc.", rating: 4.3 },
  { id: 15, logo: "https://logo.clearbit.com/uber.com", name: "Uber Technologies", rating: 4.0 },
];

const Community = () => {
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [actionType, setActionType] = useState(""); // "remove" or "unfollow"

  const getStars = (rating) => {
    const fullStars = Math.floor(rating);
    const halfStar = rating % 1 !== 0;
    const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

    return (
      <>
        {Array(fullStars).fill(<BsStarFill className="text-warning" />)}
        {halfStar && <BsStarHalf className="text-warning" />}
        {Array(emptyStars).fill(<BsStar className="text-secondary" />)}
      </>
    );
  };

  const handleActionClick = (company, type) => {
    setSelectedCompany(company);
    setActionType(type);
    setShowModal(true);
  };

  const handleConfirm = () => {
    console.log(`${actionType} company:`, selectedCompany);
    setShowModal(false);
    setSelectedCompany(null);
    setActionType("");
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedCompany(null);
    setActionType("");
  };

  return (
    <>
      <PrimarySidebar />

      <div className="js-pg-hg mt-5">
        <div className="container pb-4 cp-container">
          <div className="heading mb-4 pb-1">
            <h4>Community</h4>
          </div>

          {/* Search Bar */}
          <div className="p-4 shadow-sm rounded-3 bg-white mb-4">
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Search Companies..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <Button variant="primary" className="px-4">
                <BsSearch />
              </Button>
            </InputGroup>
          </div>

          {/* Tabs */}
          <Tab.Container defaultActiveKey="followers">
            <Nav variant="tabs" className="mb-4 border-0 py-2">
              <Nav.Item>
                <Nav.Link eventKey="followers" className="px-4 py-2 pb-3 fw-500 text-dark">
                  My Followers &nbsp; <span class="badge border-primary bg-primary rounded-5 p-2 fw-600 m-0 bg-pirmary small text-white">200</span>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="following" className="px-4 py-2 pb-3 fw-500 text-dark">
                  Following &nbsp; <span class="badge border-primary bg-white rounded-5 p-2 fw-600 m-0 bg-pirmary small text-primary">150</span>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="connected" className="px-4 py-2 pb-3 fw-500 text-dark">
                  Connected &nbsp; <span class="badge border-primary bg-white rounded-5 p-2 fw-600 m-0 bg-pirmary small text-primary">10</span>
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              {/* My Followers */}
              <Tab.Pane eventKey="followers">
                <div className="row">
                  {companies.map((company) => (
                    <div className="col-lg-4 col-sm-12 mb-4" key={company.id}>
                      <Card className="p-3 border-0 shadow-sm">
                        <Card.Body>
                          <div className="d-flex align-items-center">
                            <img src={company.logo} alt={company.name} className="rounded-circle me-3" width="50" />
                            <div className="flex-grow-1">
                              <h6 className="mb-1">{company.name}</h6>
                              <div>{getStars(company.rating)}</div>
                            </div>
                          </div>
                          <button
                              className="me-3 mt-3 position-absolute top-0 m-auto end-0 fs-5 p-0 btn btn-link text-primary"
                              onClick={() => handleActionClick(company, "Remove")}
                            >
                              <i class='bx bx-x'></i>
                            </button>
                        </Card.Body>
                      </Card>
                    </div>
                  ))}
                </div>
              </Tab.Pane>

              {/* Following */}
              <Tab.Pane eventKey="following">
                <div className="row">
                  {companies.map((company) => (
                    <div className="col-lg-3 col-sm-12 mb-4" key={company.id}>
                      <Card className="p-3 border-0 shadow-sm">
                        <Card.Body>
                          <div className="d-flex align-items-center">

                            <div className="flex-grow-1 text-center">
                            <img src={company.logo} alt={company.name} className="rounded-circle rounded-5 mb-3" width="50" height='50' />
                              <h6 className="mb-1">{company.name}</h6>
                              <div>{getStars(company.rating)}</div>
                            </div>
                          </div>
                          <div className="text-center">
                          <Button
                              variant="outline-danger"
                              className="me-2 ms-auto mt-4 btn-sm btn btn-outline-danger"
                              onClick={() => handleActionClick(company, "Unfollow")}
                            >
                              Unfollow
                            </Button>
                            </div>
                        </Card.Body>
                      </Card>
                    </div>
                  ))}
                </div>
              </Tab.Pane>

              {/* Connected */}
              <Tab.Pane eventKey="connected">
                <div className="row">
                  {companies.map((company) => (
                    <div className="col-lg-3 col-sm-12 mb-4" key={company.id}>
                      <Card className="p-3 border-0 shadow-sm">
                        <Card.Body>
                          <div className="d-flex align-items-center">
                          <div className="flex-grow-1 text-center">
                            <img src={company.logo} alt={company.name} className="rounded-circle rounded-5 mb-3" width="50" />
                              <h6 className="mb-1">{company.name}</h6>
                              <div>{getStars(company.rating)}</div>
                            </div>
                          </div>
                          <div className="text-center">
                            <Button variant="outline-primary text-primary" className="me-2 ms-auto mt-4 btn-sm" as={NavLink} to="/Messages">
                              Message
                            </Button>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  ))}
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>

          {/* Confirmation Modal */}
          <Modal
            show={showModal}
            onHide={handleClose}
            centered
            className="shadow-lg"
          >
            <Modal.Header className="bg-light border-0 py-3">
              <Modal.Title className="fw-600 text-dark">
                Confirm {actionType}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-5">
              <p className="mb-0 text-dark text-center">
                Are you sure you want to {actionType.toLowerCase()} <strong>{selectedCompany?.name}</strong>?
              </p>
              <div className="d-flex justify-content-center border-0 py-3">
                <Button
                  variant="outline-secondary"
                  className="px-4 py-2 rounded-3 me-2"
                  onClick={handleClose}
                >
                  No
                </Button>
                <Button
                  variant="primary"
                  className="px-4 py-2 rounded-3 shadow-sm"
                  onClick={handleConfirm}
                >
                  Yes, I Confirmed
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default Community;